import { action, computed, observable, set, makeObservable } from 'mobx';
import { MortgageDocumentType } from '../classes/MortgageDocumentType';
import {
  IRecordedMortgageRequired,
  IRecordedMortgage,
  constructNewRecordedMortgage,
} from '../classes/RecordedMortgage';

export class RecordedMortgageService {
  public recordedMortgage: IRecordedMortgage = observable.object(constructNewRecordedMortgage());

  private requiredFields: IRecordedMortgageRequired = observable.object({
    book: false,
    document_type: false,
    execution_date: true,
    instrument_number: false,
    lender_name: true,
    maturity_date: false,
    mortgagor_name: true,
    original_loan_amount: true,
    other_document_type: false,
    recorded_date: true,
    recorded_at: true,
    trustee_name: false,
  });

  constructor() {
    makeObservable(this, {
      setRecordedMortgage: action,
      setRequiredField: action,
      getRecordedMortgage: computed,
      getRequiredFields: computed,
      recordedMortgageReadyForSave: computed,
    });
  }

  public setRecordedMortgage(newRecordedMortgage: IRecordedMortgage) {
    set(this.recordedMortgage, newRecordedMortgage);
    this.setRequiredField('other_document_type', newRecordedMortgage.document_type === MortgageDocumentType.other);
  }

  public setRequiredField(propName: string, value: boolean) {
    set(this.requiredFields, propName, value);
  }

  public get getRecordedMortgage(): IRecordedMortgage {
    return this.recordedMortgage;
  }

  public get getRequiredFields(): IRecordedMortgageRequired {
    return this.requiredFields;
  }

  public get recordedMortgageReadyForSave(): boolean {
    let readyForSave = true;
    Object.keys(this.getRequiredFields).forEach((property) => {
      if (this.getRequiredFields[property] && !this.getRecordedMortgage[property]) {
        readyForSave = false;
      }
      if (!this.getRecordedMortgage.book && !this.getRecordedMortgage.instrument_number) {
        readyForSave = false;
      }
    });
    return readyForSave;
  }
}
